//React, React Router, Formik
import React, {useEffect, useState} from 'react';
import Head from "next/head";
import dynamic from 'next/dynamic';
const Course = dynamic(() => import("@modules/products/[slug]/Course/Course"), {ssr: false});
import {useRouter} from "next/router";

//Material UI

//Redux
import {wrapper} from "@store/store";
import {productActions} from "@store/Product/slice";
import nookies, {parseCookies} from "nookies";
import {useDispatch, useSelector} from "react-redux";
import {UnsetAccessToken} from "@store/Auth/actions";
import {AUTH} from "@helper/constants/routes";
import {getApiUrl} from "@helper/constants/constant";
import {view} from "@store/Product/actions";

//Assets

//This method must be implemented for Nprogress to work properly
export const getServerSideProps = wrapper.getServerSideProps(
    store => async (context) => {

        /*const cookies = nookies.get(context);
        if (context.query.slug) {
            try {
                let chapterIdQuery = context.query.target_chapter_id ? `?target_chapter_id=${context.query.target_chapter_id}` : '';
                let url = `${getApiUrl(context)}/api/products/${context.query.slug}/view${chapterIdQuery}`;

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Authorization': cookies.access_token,
                    }
                });
                const data = await response.json();
                store.dispatch(productActions.setViewData(data));

                console.log('RESPONSE: ', context.res);

                return {
                    props: {isAuthenticatedFromServer: store.getState().auth.isAuthenticated}
                }
            } catch (e) {
                console.log('Exception: ', e);
                UnsetAccessToken();
                return {
                    redirect: {
                        permanent: false,
                        destination: AUTH.login,
                    },
                    props:{},
                };
            }
        }*/
    }
)

const Product = (props) => {

    const dispatch = useDispatch();
    const router = useRouter();

    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const {slug, target_chapter_id} = router.query;

    const {product} = useSelector(state => state.product.viewData);

    //Calling view API from useEffect instead of getServerSideProps because the
    //later case does not create AWS signed cookies
    useEffect(() => {
        dispatch(view(slug, target_chapter_id));
    }, [isAuthenticated])

    return (
        product ?
        <>
            <Head>
                <title>{product.title}</title>
            </Head>
            <Course />
        </>
        : null
    );
};

export default Product;
